module.exports = __webpack_public_path__ + "assets/6ffe8b5f3d3407cf165eb5ef840406de.png";